/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import {
    Button,
    CircularProgress,
    Grid,
    IconButton,
    Paper,
    TextField,
    Theme,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Tooltip,
    Typography,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import { Calendar } from "../../../images/icons/components/Calendar";
import { PnbPlaceSelector } from "../../components/PnbPlaceSelector";
import RoomIcon from "@mui/icons-material/Room";
import { colors } from "../../../styles/defaultColors";
import { IAnnounce, SearchInputs } from "../../../utils/AnnounceInterfaces";
import { useHistory, useLocation, useParams } from "react-router";
import { getDayNumberProm, SortArray, useQuery } from "../../../utils/App";
import { PnBDateRange } from "../../components/PnBDateRange";
import { CountryService } from "../../Admin/Countries/services/EquipmentCountry";
import { SearchLocationCritere } from "./searchComponent/TextField";
import { searchDefaultValue } from "../../../utils/defaultNullValues";
import { CurrencyContext, UserContext } from "../../../contexts/AppContext";
import { ConvertedDeviseWithMoneySign } from "../../../utils/CurrencyConvertFunction";
import moment from "moment";
import { LoginDialog } from "../../components/Login/LoginDialog";
import { RegisterDialog } from "../../components/Register/RegisterDialog";
import { ETarifs, getTarifLabel } from "../../../utils/enum";
import { ContactButton, StickyBarContactButton } from "../../components/ContactButton";
import { PnbPlaceCitySelector } from "../../components/PnbPlaceCitySelector";
import { PnbPlaceQuartierSelector } from "../../components/PnbPlaceQuartierSelector";
import { IPays, IVille } from "../../../utils/DiversInterfaces";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PermDeviceInformationIcon from "@material-ui/icons/PermDeviceInformation";
import { useTranslation } from "react-i18next";
import FindCircuitsPopup from "./searchComponent/FindCircuitsPopup";
import MasterCard_logo from "../../../images/MasterCard_logo.jpg";
import MTNMobileMoney_logo from "../../../images/MTNMobileMoney_logo.jpg";
import OrangeMoney_logo from "../../../images/OrangeMoney_logo.jpg";
import PayPal_logo from "../../../images/PayPal_logo.jpg";
import Visa2_logo from "../../../images/Visa2_logo.jpg";


/** MAIN COMPONENT PROPS */
interface IRoomInventory {
    totalRooms: number;
    availableRooms: number;
}

export interface IReservationCardProps {
    isEmbed?: boolean;
    noProductLabel?: boolean;
    noButton?: boolean;
    withLocation?: boolean;
    announce?: IAnnounce;
    searchTypeSearch?: string;
    res_occupe?:any;
    refreshFields?:any;
    setState?:any;
    roomInventory?: IRoomInventory;
}


/** DATE PICKER COMPONENT */
export const PnbDatePicker = (props: {
    label: string;
    name: string;
    value: string;
    onChange: (name: string, newDate: string) => void;
}) => {

    const classes = useStyles();
    return (
        <>
            <h3 className={classes.date_item_title}>{props.label}</h3>
            <TextField
                inputProps={{
                    style: {
                        textAlign: "center",
                        padding: 7,
                    },
                    form: {
                        autocomplete: "off",
                    },
                }}
                name={props.name}
                classes={{ root: classes.input_base_root }}
                fullWidth
                autoFocus
                value={props.value}
                onChange={(d) => {
                    props.onChange(d.target.name, d.target.value);
                }}
                margin="dense"
                type="date"
            />
        </>
    );
};

/** NUMBER PICKER COMPONENT */
export const PnbQtePicker = (props: any) => {
    const classes = useStyles();
    const clickMoins = () => {
        props.onValueChange(props.name, props.value - 1);
    };
    const location = useLocation();
    const clickPlus = () => {
        if (
            location.pathname.startsWith("/details-announce") ||
            location.pathname.startsWith("/booking/details-announce")
        ) {
            if (props.valueTotal >= props.announce.property.maximumGuests)
                return;
        }
        if (props.name === "rooms") {
            if (props.value > 2) return;
        }

        props.onValueChange(props.name, props.value + 1);
    };

    return (
        <>
            {props.name === "rooms" ? (
                <>
                    {props.value >= 3 ? (
                        <>
                            <h3 style={{ fontSize: 14,marginTop:"14px", marginBottom:"6px" }} className={classes.date_item_title}>
                                {props.label}
                            </h3>
                            <TextField
                                inputProps={{
                                    style: {
                                        textAlign: "center",
                                        padding: 7,
                                    },
                                }}
                                classes={{ root: classes.input_base_root }}
                                autoFocus
                                margin="dense"
                                type="text"
                                name={props.name}
                                value={props.value != null ? "+" + props.value : "+0"} // Handle null or undefined
                                // disabled
                                onChange={(d) => {
                                    props.onValueChange(
                                        d.target.name,
                                        Number(d.target.value)
                                    );
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <IconButton
                                            classes={{
                                                root: classes.icon_button_root,
                                            }}
                                            onClick={clickMoins}
                                        >
                                            -
                                        </IconButton>
                                    ),
                                    endAdornment: (
                                        <IconButton
                                            classes={{
                                                root: classes.icon_button_root,
                                            }}
                                            onClick={clickPlus}
                                        >
                                            +
                                        </IconButton>
                                    ),
                                }}
                            />
                        </>
                    ) : (
                        <>
                            <h3 className={classes.date_item_title}>
                                {props.label}
                            </h3>
                            <TextField
                                inputProps={{
                                    style: {
                                        textAlign: "center",
                                        padding: 7,
                                    },
                                }}
                                classes={{ root: classes.input_base_root }}
                                autoFocus
                                margin="dense"
                                type="text"
                                name={props.name}
                                value={props.value ?? 0}
                                onChange={(d) => {
                                    props.onValueChange(
                                        d.target.name,
                                        Number(d.target.value)
                                    );
                                }}
                                // disabled
                                InputProps={{
                                    startAdornment: (
                                        <IconButton
                                            classes={{
                                                root: classes.icon_button_root,
                                            }}
                                            onClick={clickMoins}
                                        >
                                            -
                                        </IconButton>
                                    ),
                                    endAdornment: (
                                        <IconButton
                                            classes={{
                                                root: classes.icon_button_root,
                                            }}
                                            onClick={clickPlus}
                                        >
                                            +
                                        </IconButton>
                                    ),
                                }}
                            />
                        </>
                    )}
                </>
            ) : (
                <>
                    <h3 className={classes.date_item_title}>{props.label}</h3>
                    <TextField
                        inputProps={{
                            style: {
                                textAlign: "center",
                                padding: 7,
                            },
                        }}
                        classes={{ root: classes.input_base_root }}
                        autoFocus
                        margin="dense"
                        type="number"
                        name={props.name}
                        value={props.value ?? 0}
                        disabled
                        onChange={(d) => {
                            props.onValueChange(
                                d.target.name,
                                Number(d.target.value)
                            );
                        }}
                        InputProps={{
                            startAdornment: (
                                <IconButton
                                    classes={{ root: classes.icon_button_root }}
                                    onClick={clickMoins}
                                >
                                    -
                                </IconButton>
                            ),
                            endAdornment: (
                                <IconButton
                                    classes={{ root: classes.icon_button_root }}
                                    onClick={clickPlus}
                                >
                                    +
                                </IconButton>
                            ),
                        }}
                    />
                </>
            )}
        </>
    );
};

/** CARD CONTENT COMPONENT */
const countryService = new CountryService();
const ReservationCardContent = (props: any) => {
    const classes = useStyles();
    const { t, i18n } = useTranslation<'common'>();
    const searchTypeSearch=props.searchTypeSearch;
    let query = useQuery();
    const history = useHistory();
    const currencyContext = useContext(CurrencyContext);
    const { currency } = currencyContext;
    /*React.useEffect(() => {
        console.log("Current props.announce ReservationCardContent:", props.announce);
    }, [props.announce]); */


    const [priceConverted, setPriceConverted] = React.useState<number>(0);
    const [priceConvertedTotal, setPriceConvertedTotal] =
        React.useState<number>(0);
    const [priceConvertedTotalSimple, setPriceConvertedTotalSimple] =
        React.useState<number>(0);
    const [priceConvertedFinal, setPriceConvertedFinal] =
        React.useState<number>(0);   
    const [priceConvertedFinalForSelectedRooms, setPriceConvertedFinalForSelectedRooms] =
        React.useState<number>(0);          
    const [commissionFee, setCommissionFee] = React.useState<number>(0);
    const [priceConvertedClean, setPriceConvertedCleaningFees] =
        React.useState<number>(0);
    const [priceConvertedProm, setPriceConvertedProm] =
        React.useState<number>(0);

    const [priceConvertedTotalProm, setPriceConvertedTotalProm] =
        React.useState<number>(0);
    const [priceConvertedFinalProm, setPriceConvertedFinalProm] =
        React.useState<number>(0);
    const [preReservation, setPreReservation] = React.useState({
        dci: query.get("dci") || "",
        dco: query.get("dco") || "",
        travellerAdultTotal: Number(query.get("travellerAdultTotal") ?? 2),
        travellerChildTotal: Number(query.get("travellerChildTotal")),
    });
    const [refreshKey, setRefreshKey] = React.useState(0);
    const [jour, setJour] = React.useState<number>(1);
    const [jourSimple, setJourSimple] = React.useState<number>(1);
    const [jourProm, setJourProm] = React.useState<number>(1);
    const [, setPays] = React.useState<string>("");
    const [city, setCity] = React.useState<string>(
        query.get("search_adresse") || ""
    );
    const [quartier, setQuartier] = React.useState<string>(
        query.get("quartier") || ""
    );
    const [paysList, setPaysList] = React.useState<any[]>();
    const [cityList, setCityList] = React.useState<any[]>();
    const [quartierList, setQuartierList] = React.useState<any[]>();
    const [devise, setDevise] = React.useState("");
    const [loadingPrice, setLoadingPrice] = React.useState<Boolean>(false);
    const location = useLocation();
    const [countries, setCountries] = React.useState<IPays[]>([]); // Array of IPays objects
    const [cities, setCities] = React.useState<IVille[]>([]); // Array of IVille objects
    const [quartiers, setQuartiers] = React.useState<string[]>([]); // Array of quartiers (strings)
    const [selectedCountry, setSelectedCountry] = React.useState<string>(""); // Country ID as string
    const [selectedCity, setSelectedCity] = React.useState<string>(""); // City ID as string
    const [selectedQuartier, setSelectedQuartier] = React.useState<string>(""); // Quartier name as string
    const [countryInput, setCountryInput] = React.useState<String>("");
    const [cityInput, setCityInput] = React.useState<String>("");
    const [quartierInput, setQuartierInput] = React.useState<String>("");
    const [tarif, setTarif] = React.useState(ETarifs.JOURNALIER);
    const [selectedQuartiers, setSelectedQuartiers] = React.useState<string[]>([]);
    const [selectedRooms, setSelectedRooms] = React.useState<number>(
        props.searchTypeSearch === "htls" 
            ? Number(query.get("selectedRooms") || 1)
            : 1
    );

    const handleRoomChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const rooms = Number(event.target.value);
        if (props.searchTypeSearch === "htls") {
            onChangeValue("selectedRooms", rooms);
        }
        setSelectedRooms(rooms);
    };
    
    let jours: number;
    let nbjours_prom: number = 0;
    let nbjours_simple: number = 0;
    if ((query.get("dco") || "") && (query.get("dci") || "")) {
        var msMinute = 60 * 1000,
            msDay = 60 * 60 * 24 * 1000,
            a: any = new Date(query.get("dci") || ""),
            b: any = new Date(query.get("dco") || "");
        jours = Math.floor((b - a) / msDay);
    } else {
        jours = 1;
    }
    let dateCheck: any = [];
    for (let i = 0; i < jour; i++) {
        dateCheck.push(
            moment(
                new Date(
                    moment(
                        new Date(query.get("dci") || "").setDate(
                            new Date(query.get("dci") || "").getDate() + i
                        )
                    ).format("YYYY/MM/DD")
                )
            ).format("YYYY/MM/DD")
        );
    }
    let icluRes: any = [];
    if (location.pathname !== "/search" && !location.pathname.startsWith("/stays")) {
            if (
            props.res_occupe[0] !== undefined &&
            props.announce?.property.type.name !== "Hôtel"
        ) {
            props.res_occupe.forEach((inc: any) => {
                let test = dateCheck.includes(moment(inc).format("YYYY/MM/DD"));
                icluRes.push(test);
            });
        }
        if (props.announce.dateIndisponible !== undefined) {
            props.announce.dateIndisponible.forEach((inc: any) => {
                let test = dateCheck.includes(moment(inc).format("YYYY/MM/DD"));
                icluRes.push(test);
            });
        }
    }

    React.useEffect(() => {
        // Fetch countries with populated 'villes' field
        countryService.getAllCountries().then((response: { success: boolean; data: IPays[] }) => {
            if (response.success) {
                setCountries(response.data);
    
                // Check URL keys after fetching countries
                const searchPays = query.get("search_pays");
                const searchAdresse = query.get("search_adresse");
                const searchQuartier = query.get("quartier");
    
                if (searchPays) {
                    const country = response.data.find((c) => c._id === searchPays);
                    if (country) {
                        setSelectedCountry(country._id); // Set country ID
                        setCities(country.villes || []); // Populate cities
                        setDevise(country.currencyCode);
                        //console.log("Country selected from URL:", country);
                    } else {
                        console.warn("Country from URL not found.");
                    }
                }
    
                if (searchPays && searchAdresse) {
                    const country = response.data.find((c) => c._id === searchPays);
                    if (country) {
                        const city = country?.villes?.find((v) => v._id === searchAdresse);
                        if (city) {
                            setSelectedCity(city._id ?? ""); // Set city ID
                            setQuartiers(city.quartiers || []); // Populate quartiers
                            //console.log("City selected from URL:", city);
                        } else {
                            console.warn("City from URL not found in selected country.");
                        }
                    }
                }
    
                if (searchQuartier) {
                    setSelectedQuartier(searchQuartier); // Set quartier directly
                    //console.log("Quartier selected from URL:", searchQuartier);
                }
            } else {
                console.error("Failed to fetch countries");
            }
        });
    }, []);

    React.useEffect(() => {
        if (selectedCountry) {
            const country = countries.find(country => country._id.toString() === selectedCountry);
            if (country) {
                setCities(country.villes || []); // Set cities from selected country’s 'villes' field
                //console.log("Cities for selected country:", country.villes);
                setDevise(country.currencyCode);
            } else {
                //console.log("Country not found or has no cities.");
                setCities([]); // Reset if country not found
                setDevise("");
                
            }
            setSelectedCity(""); // Reset city and quartier when country changes
            setQuartiers([]);
            setSelectedQuartier("");
        }
    }, [selectedCountry, countries]);

    React.useEffect(() => {
        if (selectedCity) {
            const city = cities.find(city => city?._id?.toString() === selectedCity);
            if (city) {
                //console.log("Found city:", city); // Debugging line to confirm the correct city object
                setQuartiers(city.quartiers || []); // Set quartiers from city or use empty array
            } else {
                //console.log("City not found in cities array."); // Debugging line if city is not found
                setQuartiers([]); // Reset if city not found
            }
            setSelectedQuartier(""); // Reset selected quartier on city change
        } else {
            setQuartiers([]); // Clear quartiers if no city is selected
            setSelectedQuartier(""); // Reset selected quartier 
            //console.log("selectedCity is empty or cities array is empty."); // Debugging line if condition fails
        }
    }, [selectedCity, cities]);



    const onChangeCountry = (country: IPays | null) => {
        if (country && country._id) {
            setSelectedCountry(country._id);   // Set the country ID
            setCities(country.villes || []);   // Populate cities if the country has villes; otherwise, empty list
            setSelectedCity("");               // Clear the selected city
            setSelectedQuartier("");           // Reset selected quartier
            setQuartiers([]);                  // Clear quartiers list

           //console.log("Country changed:", country);

        } else {
            setSelectedCountry("");            // Clear country selection if no valid country
            setCities([]);                     // Clear cities
            setSelectedCity("");               // Clear city selection
            setSelectedQuartier("");           // Clear quartier selection
            setQuartiers([]);                  // Clear quartiers
        }
    };

    const onChangeCity = (city: IVille | null): void => {
        if (city && city._id) {
            setSelectedCity(city._id);            // Set the city ID
            setQuartiers(city.quartiers || []);    // Populate quartiers from the selected city
            setSelectedQuartier("");               // Reset quartier when city changes            
        } else {
            setSelectedCity("");
            setQuartiers([]);                      // Clear quartiers if city is null
            setSelectedQuartier("");
        }
    };


     // Handle quartier change
    const onChangeQuartier = (value: any): void => {
        setSelectedQuartier(value);
        //console.log("Quartier changed:", value);
    };


    

    const [search, setSearch] = React.useState<SearchInputs>({
        ...searchDefaultValue,
        country: query.get("search_pays") || "",
        city: query.get("search_adresse") || "",
        quartier: query.get("quartier") || "",
    });

    const { id } = useParams<{ id: string }>();

    React.useEffect(() => {
        setLoadingPrice(true);
        setLoadingCountry(true);
        countryService.getAllCountries().then((response) => {
            if (response.success) {
                setPaysList(response.data.sort(SortArray));
            }
        }).then(()=>{
            setTimeout(() => {
                setLoadingCountry(false);
            },1000)
        }).catch(console.log);
        let percentage = 0;
        if (props.announce?.property.type.name === "Hôtel") {
            countryService
                .getSpecialFeeByPropertyType(props.announce?.property.type.name)
                .then((response) => {
                    if (response.success) {
                        percentage = response.data
                            ? response.data.percentageTraveller
                            : 0;
                        setCommissionFee(percentage);
                        let normalPrice;
                        let priceApplied = false;

                        // Try monthly first (30+ days)
                        if (jour >= 30 && props.announce.priceMonthly && props.announce.priceMonthly > 0) {
                            normalPrice = (
                                props.announce.priceMonthly / 30 +
                                (props.announce.priceMonthly / 30) * (percentage / 100)
                            ).toFixed(2);
                            setTarif(ETarifs.MENSUEL);
                            priceApplied = true;
                        } 
                        // If monthly not available, try biweekly (14-29 days)
                        if (!priceApplied && jour >= 14 && props.announce.priceBiWeekly && props.announce.priceBiWeekly > 0) {
                            normalPrice = (
                                props.announce.priceBiWeekly / 14 +
                                (props.announce.priceBiWeekly / 14) * (percentage / 100)
                            ).toFixed(2);
                            setTarif(ETarifs.QUINZAINE);
                            priceApplied = true;
                        } 
                        // If biweekly not available, try weekly (7+ days)
                        if (!priceApplied && jour >= 7 && props.announce.priceWeekly && props.announce.priceWeekly > 0) {
                            normalPrice = (
                                props.announce.priceWeekly / 7 +
                                (props.announce.priceWeekly / 7) * (percentage / 100)
                            ).toFixed(2);
                            setTarif(ETarifs.HEBDOMADAIRE);
                            priceApplied = true;
                        }
                        // Final fallback to daily price
                        if (!priceApplied) {
                            normalPrice = (
                                props.announce.price +
                                props.announce.price * (percentage / 100)
                            ).toFixed(2);
                            setTarif(ETarifs.JOURNALIER);
                        }
                        ConvertedDeviseWithMoneySign(
                            props.announce.devise || "XAF",
                            currency,
                            normalPrice
                        )
                            .then((value: any): any => {
                                setPriceConverted(value);
                                setLoadingPrice(false);
                            })
                            .catch((error) => console.log(error));
                    }
                })
                .catch(console.log)
                .finally(() => {
                    setTimeout(() => {
                        setLoadingPrice(false);
                    }, 8000);
                });
        } else {
            countryService
                .getCommissionFeeByCountryIdAndCityId(
                    props.announce?.property?.address?.country?._id,
                    props.announce?.property?.address?.city?._id
                )
                .then((respCom) => {
                    console.log("CommissionFeeByCountryIdAndCityId from ReservationCard")
                    if (respCom.success) {
                        percentage = respCom.data ? respCom.data.percentage : 0;
                        setCommissionFee(percentage);
                        let normalPrice;
                        let priceApplied = false;

                        // Try monthly first (30+ days)
                        if (jour >= 30 && props.announce.priceMonthly && props.announce.priceMonthly > 0) {
                            normalPrice = (
                                props.announce.priceMonthly / 30 +
                                (props.announce.priceMonthly / 30) * (percentage / 100)
                            ).toFixed(2);
                            setTarif(ETarifs.MENSUEL);
                            priceApplied = true;
                        } 
                        // If monthly not available, try biweekly (14-29 days)
                        if (!priceApplied && jour >= 14 && props.announce.priceBiWeekly && props.announce.priceBiWeekly > 0) {
                            normalPrice = (
                                props.announce.priceBiWeekly / 14 +
                                (props.announce.priceBiWeekly / 14) * (percentage / 100)
                            ).toFixed(2);
                            setTarif(ETarifs.QUINZAINE);
                            priceApplied = true;
                        } 
                        // If biweekly not available, try weekly (7+ days)
                        if (!priceApplied && jour >= 7 && props.announce.priceWeekly && props.announce.priceWeekly > 0) {
                            normalPrice = (
                                props.announce.priceWeekly / 7 +
                                (props.announce.priceWeekly / 7) * (percentage / 100)
                            ).toFixed(2);
                            setTarif(ETarifs.HEBDOMADAIRE);
                            priceApplied = true;
                        }
                        // Final fallback to daily price
                        if (!priceApplied) {
                            normalPrice = (
                                props.announce.price +
                                props.announce.price * (percentage / 100)
                            ).toFixed(2);
                            setTarif(ETarifs.JOURNALIER);
                        }
                        ConvertedDeviseWithMoneySign(
                            props.announce.devise || "XAF",
                            currency,
                            normalPrice
                        )
                            .then((value: any): any => {
                                setPriceConverted(value);
                                setLoadingPrice(false);
                            })
                            .catch((error) => console.log(error));
                    }
                })
                .catch(console.log)
                .finally(() => {
                    setTimeout(() => {
                        setLoadingPrice(false);
                    }, 8000);
                });
        }
    }, [currency, jour]);

    


    if (location.pathname.startsWith("/details-announce")) {
        if (props.announce.promotion) {
            nbjours_prom = getDayNumberProm(
                preReservation.dci,
                preReservation.dco,
                moment(props.announce.promotion.startDate).format("YYYY-MM-DD"),
                moment(props.announce.promotion.endDate).format("YYYY-MM-DD"),
                props.announce.price,
                props.announce.promotion.price
            ).DateProm;
            nbjours_simple = getDayNumberProm(
                preReservation.dci,
                preReservation.dco,
                moment(props.announce.promotion.startDate).format("YYYY-MM-DD"),
                moment(props.announce.promotion.endDate).format("YYYY-MM-DD"),
                props.announce.price,
                props.announce.promotion.price
            ).DateSimple;
        }
    }



    React.useEffect(() => {
        if (jourSimple !== nbjours_simple) {
            setJourSimple(nbjours_simple);
        }
        if (jour !== jours) {
            setJour(jours);
        }
        if (jourProm !== nbjours_prom) {
            setJourProm(nbjours_prom);
        }
    }, [nbjours_simple, jours, nbjours_prom]); 


    
    React.useEffect(() => {
        if (location.pathname.startsWith("/details-announce")) {
            // setLoadingPrice(true);
            let pricePromotion;
            if (props.announce.promotion) {
                pricePromotion =
                    props.announce.promotion.price +
                    props.announce.promotion.price * (commissionFee / 100);
            }

            let priceNormal;
            let priceApplied = false;

            // Try monthly rate first (30+ days)
            if (jour >= 30 && props.announce.priceMonthly && props.announce.priceMonthly > 0) {
                priceNormal = props.announce.priceMonthly / 30 + 
                            (props.announce.priceMonthly / 30) * (commissionFee / 100);
                priceApplied = true;
            }

            // If monthly not available or duration <30 days, try biweekly (14+ days)
            if (!priceApplied && jour >= 14 && props.announce.priceBiWeekly && props.announce.priceBiWeekly > 0) {
                priceNormal = props.announce.priceBiWeekly / 14 + 
                            (props.announce.priceBiWeekly / 14) * (commissionFee / 100);
                priceApplied = true;
            }

            // If biweekly not available or duration <14 days, try weekly (7+ days)
            if (!priceApplied && jour >= 7 && props.announce.priceWeekly && props.announce.priceWeekly > 0) {
                priceNormal = props.announce.priceWeekly / 7 + 
                            (props.announce.priceWeekly / 7) * (commissionFee / 100);
                priceApplied = true;
            }

            // Final fallback to daily rate if no other rates apply
            if (!priceApplied) {
                priceNormal = props.announce.price + 
                            props.announce.price * (commissionFee / 100);
            }
            const priceWithDays = priceNormal * jours;
            const priceWithDaysPromotion = pricePromotion * nbjours_prom;
            const priceWithDaysSimple = priceNormal * jourSimple;
            const priceWithDaysWithCleanningAndCmomissionProm =
                priceWithDaysPromotion +
                priceWithDaysSimple +
                props.announce.cleaningFees +
                props.announce.cleaningFees * (commissionFee / 100);
            ConvertedDeviseWithMoneySign(
                props.announce.devise,
                currency,
                pricePromotion
            )
                .then((value: any): any => setPriceConvertedProm(value))
                .catch((error) => console.log(error));

            ConvertedDeviseWithMoneySign(
                props.announce.devise,
                currency,
                priceWithDaysPromotion
            )
                .then((value: any): any => setPriceConvertedTotalProm(value))
                .catch((error) => console.log(error));

            ConvertedDeviseWithMoneySign(
                props.announce.devise,
                currency,
                priceWithDaysWithCleanningAndCmomissionProm
            )
                .then((value: any): any => setPriceConvertedFinalProm(value))
                .catch((error) => console.log(error));

            const priceWithDaysWithCleanningAndCmomission =
                priceWithDays +
                props.announce.cleaningFees +
                props.announce.cleaningFees * (commissionFee / 100);

            const priceWithDaysWithCleanningAndCmomissionForSelectedRooms =
                (priceWithDays +
                props.announce.cleaningFees +
                props.announce.cleaningFees * (commissionFee / 100)) * selectedRooms;

            ConvertedDeviseWithMoneySign(
                props.announce.devise,
                currency,
                priceWithDays
            )
                .then((value: any): any => {
                    setPriceConvertedTotal(value);
                })
                .catch((error) => console.log(error));

            ConvertedDeviseWithMoneySign(
                props.announce.devise,
                currency,
                priceWithDaysSimple
            )
                .then((value: any): any => setPriceConvertedTotalSimple(value))
                .catch((error) => console.log(error));

            ConvertedDeviseWithMoneySign(
                props.announce.devise,
                currency,
                props.announce.cleaningFees +
                    props.announce.cleaningFees * (commissionFee / 100)
            )
                .then((value: any): any => setPriceConvertedCleaningFees(value))
                .catch((error) => console.log(error));

            ConvertedDeviseWithMoneySign(
                props.announce.devise,
                currency,
                priceWithDaysWithCleanningAndCmomission
            )
                .then((value: any): any => setPriceConvertedFinal(value))
                .catch((error) => console.log(error));

            ConvertedDeviseWithMoneySign(
                props.announce.devise,
                currency,
                priceWithDaysWithCleanningAndCmomissionForSelectedRooms
            )
                .then((value: any): any => setPriceConvertedFinalForSelectedRooms(value))
                .catch((error) => console.log(error));
        // setLoadingPrice(false);
        }
    }, [currency, jour, query]);

    const userContext = React.useContext(UserContext);
    const { user } = userContext;

    const [openDialog, setOpenDialog] = React.useState(false);
    const [openRegister, setOpenRegister] = React.useState(false);
    const [loadingCountry, setLoadingCountry] = React.useState(false);
    const [loadingCity, setLoadingCity] = React.useState(false);
    const [loadingQuartier, setLoadingQuartier] = React.useState(false);

    const handleClickOpenLoginDialog = () => { 
        setOpenRegister(false);
        setOpenDialog(true);
    };

    const handleCloseLoginDialog = () => {
        setOpenDialog(false);
    };

    //OPENT / CLOSE REGISTER MODAL

    const handleClickOpenRegister = () => {
        setOpenRegister(true);
        setOpenDialog(false);
    };

    const handleCloseRegister = () => {
        setOpenRegister(false);
    };

    const handleReservation = () => {

        // Track AddToCart event
        if (typeof window.fbq === 'function') {
            window.fbq('track', 'AddToCart', {
            content_ids: [props.announce._id],
            content_name: props.announce.property.name,
            content_type: props.announce.property.type.name,
            content_category: props.announce.property.type.searchType.name,
            currency: props.announce.devise || 'XAF',
            value: props.announce.price,
            contents: [{
                id: props.announce._id,
                quantity: selectedRooms // Use selectedRooms for quantity if it's a hotel
            }],
            });
        }
        
        // Format dates to yyyy-mm-dd before setting in query params
        const formattedDci = moment(preReservation.dci).format("YYYY-MM-DD");
        const formattedDco = moment(preReservation.dco).format("YYYY-MM-DD");

        query.set("dci", formattedDci);
        query.set("dco", formattedDco);
        query.set(
            "travellerAdultTotal",
            preReservation.travellerAdultTotal.toString()
        );
        query.set(
            "travellerChildTotal",
            preReservation.travellerChildTotal.toString()
        );

        // Add selectedRooms to query if it's a hotel
        if (props.searchTypeSearch === "htls") {
            query.set("selectedRooms", selectedRooms.toString());
        }


        if (user._id !== "") {
            history.push(`/booking/details-announce-${id}?${query.toString()}`);
        } else {
            history.push(`/guestbooking/details-announce-${id}?${query.toString()}`);
        }
    };
    

    const onChangeDate = (n: string, d: string) => {
        setPreReservation({
            ...preReservation,
            [n]: d,
        });
        if (location.pathname !== "/search"  && !location.pathname.startsWith("/stays")) {
            query.set(n, d.replace(/\/+/g, "-"));
            query.set("travellerAdultTotal", "2");
            history.push({ search: query.toString() });
        }
    };

    const onChangeValue = (n: string, v: number) => {
        if (v < 0) return;
        if (location.pathname !== "/search"  && !location.pathname.startsWith("/stays")) {
            query.set(n, v.toString());
            // Also update rooms in query if it's a hotel
            if (n === "selectedRooms" && props.searchTypeSearch === "htls") {
                query.set("selectedRooms", v.toString());
            }
            history.push({ search: query.toString() });
        }
        setPreReservation({
            ...preReservation,
            [n]: v,
        });
    };


    React.useEffect(() => {
        if (props.refreshFields !== 0) {
            setSelectedCountry("");
            setSelectedCity("");
        }
    }, [props.refreshFields]);
    
    // Update quartier when 'search_quartier' changes
    React.useEffect(() => {
        setQuartier(query.get("quartier")!);
    }, [query.get("quartier")]);

    // Update city when 'search_adresse' changes
    React.useEffect(() => {
        setCity(query.get("search_adresse")!);
    }, [query.get("search_adresse")]);

    React.useEffect(() => {
        const quartierQuery = query.get("quartier");
        if (quartierQuery) {
            setSelectedQuartiers(quartierQuery.split(","));
        }
    }, [query.get("quartier")]);

    React.useEffect(() => {
        //console.log("Quartiers available:", quartiers);
        //console.log("Selected Quartiers:", selectedQuartiers);
    }, [quartiers, selectedQuartiers]);
    
    
    
    const handleQuartierChange = (selectedValues: string[]) => {
        const updatedQuartiers = selectedValues.slice(0, 5); // Limit selection to 5 quartiers
        setSelectedQuartiers(updatedQuartiers);
    
        // Update query immediately
        if (updatedQuartiers.length > 0) {
            query.set("quartier", updatedQuartiers.join(","));
        } else {
            query.delete("quartier");
        }
        history.replace({ search: query.toString() }); // Update URL query without reloading
    };
    
      
    const handleClickSearch = () => {
            //console.log("Selected Country ID:", selectedCountry); // Debug selected country
            //console.log("Countries list:", countries); // Debug available countries

        const selectedCountryObj = countries.find((country) => country._id === selectedCountry);
            if (!selectedCountryObj) {
                console.warn("Country not found");
                return;
            }

            //console.log("Selected Country Object:", selectedCountryObj); // Debug found country

            // Find the selected city object
            //console.log("Selected City ID:", selectedCity); // Debug selected city
            //console.log("Cities list:", cities); // Debug available cities

            const selectedCityObj = cities.find((city) => city._id === selectedCity);
            if (!selectedCityObj) {
                console.warn("City not found");
                return;
            }

            //console.log("Selected City Object:", selectedCityObj); // Debug found city

        // Retrieve _id for country and city
        const countryId = selectedCountryObj._id;
        const cityId = selectedCityObj._id;

        //console.log("Final countryId and cityId for search:", { countryId, cityId });

       
        setRefreshKey((oldKey) => oldKey + 1);
        if (preReservation.dco !== "" && preReservation.dci !== "") {

            query.set("currencyBase", devise.toString());
            query.set("search_pays", countryId);
            if (cityId) {
                query.set("search_adresse", cityId);
            }
            if (selectedQuartiers.length > 0) {
                query.set("quartier", selectedQuartiers.join(","));
            } else {
                query.delete("quartier"); 
            }
            query.set(
                "travellerAdultTotal",
                preReservation.travellerAdultTotal.toString()
            );
            query.set(
                "travellerChildTotal",
                preReservation.travellerChildTotal.toString()
            );
            query.set("dco", moment(preReservation.dco).format("YYYY/MM/DD"));
            query.set("dci", moment(preReservation.dci).format("YYYY/MM/DD"));
            query.set("search_on_map", "false");

            query.set("refreshData", "0");
            query.delete("boundaries");
            query.set(`page`, "1");

        } else {

            query.set("currencyBase", devise.toString());
            query.set("search_pays", countryId);
            query.set(
                "travellerAdultTotal",
                preReservation.travellerAdultTotal.toString()
            );
            query.set(
                "travellerChildTotal",
                preReservation.travellerChildTotal.toString()
            );
            if (cityId) {
                query.set("search_adresse", cityId);
            }
            query.set("quartier", selectedQuartier || "");
            query.set("search_on_map", "false");
            query.set("refreshData", "0");
            query.delete("boundaries");
            query.set(`page`, "1");
        }
        if (props.setState) props.setState(false);
        history.push({ search: query.toString() });
    };
    // console.log("priceConvertedTotalSimple",priceConvertedTotalSimple)

    const separatorStyle = {
        borderTop: '1px solid #7D7D7D',
        width: '40%', // Set the width to 40% of the available space
        margin: '15px auto', // Add margin for spacing and center horizontally
    };

    const paymentLogos =
        props.announce?.property?.address?.country.name === "Cameroon"
            ? [MTNMobileMoney_logo, OrangeMoney_logo, PayPal_logo, Visa2_logo, MasterCard_logo]
            : [PayPal_logo, Visa2_logo, MasterCard_logo];
        

    return (
        <>
            <div className={classes.scrollableContent}>
            {!props.noProductLabel && (
                (searchTypeSearch !== "trs" || (searchTypeSearch === "trs" && props.announce?.property?.type.name === "Circuit")) && (
                    <div style={{ lineHeight: "22px" }}>
                        {query.get("offer") === "1" ||
                        props.announce.superOffer === 1 ||
                        jourProm > 0 ? (
                            isNaN(
                                parseInt(
                                    priceConvertedProm
                                        .toString()
                                        .replace(currency?.toUpperCase(), "")
                                )
                            ) ||
                            isNaN(
                                parseInt(
                                    priceConverted
                                        .toString()
                                        .replace(currency?.toUpperCase(), "")
                                )
                            ) ||
                            Number(
                                priceConverted
                                    .toString()
                                    .replace(currency.toUpperCase(), "")
                            ) <= 0 ||
                            Number(
                                priceConvertedProm
                                    .toString()
                                    .replace(currency.toUpperCase(), "")
                            ) <= 0 ? (
                                <CircularProgress
                                    size={16}
                                    style={{ color: "#890608" }}
                                />
                            ) : (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <div>
                                        <span
                                            className={classes.price}
                                            style={{
                                                fontSize: 16,
                                                textDecoration:
                                                    "line-through rgb(238, 186, 65)",
                                            }}
                                        >
                                            {priceConverted}
                                        </span>{" "}
                                        {searchTypeSearch === "apts" || searchTypeSearch === "htls"
                                            ? t("label.par-nuit")
                                            : searchTypeSearch === "cars"
                                            ? t("label.par-jour")
                                            : searchTypeSearch === "trs" && props.announce.property.type.name === 'Circuit'
                                            ? t("label.par-prestation") // Per service for Circuit type under "trs"
                                            : null}
                                    </div>
                                    <>
                                        <span className={classes.price}>
                                            {priceConverted}
                                        </span>{" "}
                                        {searchTypeSearch === "apts" || searchTypeSearch === "htls"
                                            ? t("label.par-nuit") // Per night for apartments/hotels
                                            : searchTypeSearch === "cars"
                                            ? t("label.par-jour") // Per day for cars
                                            : searchTypeSearch === "trs" && props.announce.property.type.name === 'Circuit'
                                            ? t("label.par-prestation") // Per service for Circuit type under "trs"
                                            : null}
                                    </>
                                </div>
                            )
                        ) : isNaN(
                            parseInt(
                                priceConverted
                                    .toString()
                                    .replace(currency?.toUpperCase(), "")
                            )
                        ) || priceConverted <= 0 ? (
                            <CircularProgress
                                size={16}
                                style={{ color: "#890608" }}
                            />
                        ) : (
                            <>
                                <span className={classes.price}>
                                    {priceConverted}
                                </span>{" "}
                                {searchTypeSearch === "apts" || searchTypeSearch === "htls"
                                    ? t("label.par-nuit") // Per night for apartments/hotels
                                    : searchTypeSearch === "cars"
                                    ? t("label.par-jour") // Per day for cars
                                    : searchTypeSearch === "trs" && props.announce.property.type.name === 'Circuit'
                                    ? t("label.par-prestation") // Per service for Circuit type under "trs"
                                    : null}
                            </>
                        )}
                    </div>
                )
            )}

        {(searchTypeSearch === "rstt" || searchTypeSearch === "trs") ? (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px' }}>
                

                <ContactButton />

            </div>
        ) : ( 
        <>       
            {!preReservation.dci && (
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    className={classes.price_title}
                >
                    <Calendar
                        style={{ marginRight: 16, color: colors.danger }}
                    />
                    <span>{t("label.price-title")}</span>
                </Grid>
            )}
            {searchTypeSearch !== 'rstt' && searchTypeSearch !== 'trs' && (
            <Grid
                container
                justifyContent="space-between"
                spacing={2}
                style={{ marginTop: 24 }}
            >
                <PnBDateRange
                    dco={preReservation.dco}
                    dci={preReservation.dci}
                    changeValue={onChangeDate}
                />
            </Grid>)}

            {props.withLocation && (
                <>
                        <Grid container>
                            <PnbPlaceSelector
                                label={t("home.destination")}
                                title={t(
                                    "reservationCard.label.ou-voulez-vous-aller"
                                )}
                                placeHolder={t(
                                    "reservationCard.label.pays-ville-ou"
                                )}
                                preIcon={
                                    <RoomIcon
                                        sx={{ color: colors.orangePng }}
                                    />
                                }
                                id="propertyEquipments"
                                name="name4"
                                selectedValues={selectedCountry}
                                values={countries}
                                setCountryInput={setCountryInput}
                                onChangeSelect={onChangeCountry}
                                loadingCountry={loadingCountry}
                            />
                        </Grid>
                </>
            )}
            {location.pathname === "/search" || location.pathname === "/vsearch" || location.pathname.startsWith("/stays") ? (
                <>
                        <Grid container>
                            <PnbPlaceCitySelector
                                label={t("home.ville")}
                                //title={t("reservationCard.label.ville-ou-quartier")}
                                placeHolder={t("reservationCard.label.ville-ou")}
                                preIcon={
                                    <RoomIcon
                                        sx={{ color: colors.orangePng }}
                                    />
                                }
                                id="citySelector"
                                name="name5"
                                selectedCityValues={selectedCity}
                                values={cities} // Assuming cityList contains city options
                                setCityInput={setCityInput} // Passes selected city
                                onChangeSelect={onChangeCity} // Handles city selection
                                loadingCity={loadingCity} // Boolean flag for loading state
                            />
                        </Grid>
                    </>    
                ) : (
                ""
            )}
            {location.pathname === "/search" || location.pathname.startsWith("/stays") ? (
                <>
                        <Grid container>
                            <PnbPlaceQuartierSelector
                                secondStyle
                                label={t("home.quartier")}
                                //title={t("reservationCard.label.ville-ou-quartier")}
                                placeHolder={t("reservationCard.label.quartier-ou")}
                                preIcon={
                                    <RoomIcon
                                        sx={{ color: colors.orangePng }}
                                    />
                                }
                                id="quartierSelector"
                                name="name6"
                                selectedQuartierValues={selectedQuartiers}
                                values={quartiers} // Assuming cityList contains city options
                                onChangeSelect={handleQuartierChange}
                            />
                        </Grid>
                    </>    
                ) : (
                ""
            )}
            {searchTypeSearch !== 'rstt' && (
            <Grid
                container
                justifyContent="space-between"
                spacing={2}
                style={{ marginTop: 13, marginBottom: 13 }}
            >
                <Grid item md={6} lg={6} sm={6} xs={6}>
                    <PnbQtePicker
                        name="travellerAdultTotal"
                        label={t("label.adultes")}
                        value={preReservation.travellerAdultTotal}
                        valueTotal={
                            preReservation.travellerAdultTotal +
                            preReservation.travellerChildTotal
                        }
                        annonce={props.announce}
                        onValueChange={onChangeValue}
                    />
                </Grid>
                <Grid item md={6} lg={6} sm={6} xs={6}>
                    <PnbQtePicker
                        name="travellerChildTotal"
                        label={t("label.enfants")}
                        value={preReservation.travellerChildTotal}
                        valueTotal={
                            preReservation.travellerAdultTotal +
                            preReservation.travellerChildTotal
                        }
                        annonce={props.announce}
                        onValueChange={onChangeValue}
                    /> 
                    {(location.pathname.startsWith("/details-announce") && props.searchTypeSearch === 'htls') && (
                    <Grid item xs={12} style={{ marginTop: 13 }}>
                        <h3 className={classes.date_item_title}>{t("label.number_of_rooms")}</h3>
                        <TextField
                            select
                            value={selectedRooms}
                            onChange={handleRoomChange}
                            variant="outlined"
                            SelectProps={{
                                native: true,
                                style: {
                                    height: '35px',
                                    lineHeight: '35px',
                                },
                            }}
                            style={{
                                width: '50%', // 6 columns (6/12 = 50%)
                                height: '35px',
                            }}
                            InputProps={{
                                style: {
                                    height: '35px',
                                },
                            }}
                            inputProps={{
                                style: {
                                    height: '35px',
                                    padding: '8px 12px',
                                },
                            }}
                        >
                            {props.announce?.property?.roomInventory?.totalRooms > 1 ? (
                                Array.from(
                                    { length: props.announce?.property?.roomInventory?.totalRooms }, 
                                    (_, i) => i + 1
                                ).map((num) => (
                                    <option key={num} value={num}>
                                        {num}
                                    </option>
                                ))
                            ) : (
                                <option value={1}>1</option>
                            )}
                        </TextField>
                    </Grid>
                )}         
                </Grid>
                
            </Grid> )}
            {location.pathname === "/search" || location.pathname === "/vsearch" || location.pathname.startsWith("/stays") ? (
                <Button
                    size="medium"
                    className={classes.searchButton}
                    onClick={handleClickSearch}
                >
                    {t("searchBar.search")}
                </Button>
            ) : (
                ""
            )}
            {location.pathname !== "/search"  ? (
                preReservation.dci !== "" &&
                preReservation.dco !== "" &&
                moment(
                    preReservation.dci !== "" ? preReservation.dci : new Date()
                ).diff(moment(), "month") < 12 &&
                jour >= 1 ? (
                    !icluRes.includes(true) ||
                    props.announce?.property?.type.name === "Hôtel" ? (
                        <>
                            {props.announce.promotion ? (
                                isNaN(
                                    parseInt(
                                        priceConvertedFinalProm
                                            .toString()
                                            .replace(currency.toUpperCase(), "")
                                    )
                                ) ||
                                Number(
                                    priceConvertedFinalProm
                                        .toString()
                                        .replace(currency.toUpperCase(), "")
                                ) <= 0 ||
                                priceConverted <= 0 ||
                                loadingPrice ? (
                                    <CircularProgress
                                        size={16}
                                        style={{ color: "#890608" }}
                                    />
                                ) : (
                                    <>
                                        {jourSimple > 0 ? (
                                            <Grid
                                                container
                                                justifyContent="space-between"
                                                spacing={2}
                                                style={{
                                                    marginTop: 13,
                                                    marginBottom: 13,
                                                }}
                                            >
                                                <Grid
                                                    item
                                                    md={8}
                                                    lg={8}
                                                    sm={8}
                                                    xs={8}
                                                >
                                                    {getTarifLabel(tarif)}
                                                </Grid>
                                                <Grid
                                                    item
                                                    md={7}
                                                    lg={7}
                                                    sm={7}
                                                    xs={7}
                                                >
                                                    {location.pathname !== "/search" ? (
                                                        <span>
                                                            {priceConverted} x{" "}
                                                            {jourSimple}{" "}
                                                        </span>
                                                    ) : (
                                                        ""
                                                    )}
                                                </Grid>
                                                {
                                                    <Grid
                                                        container
                                                        item
                                                        md={5}
                                                        lg={5}
                                                        sm={5}
                                                        xs={5}
                                                        style={{ textAlign: 'right' }}
                                                    >
                                                            {
                                                                priceConvertedTotalSimple
                                                            }
                                                        
                                                    </Grid>
                                                }
                                            </Grid>
                                        ) : (
                                            ""
                                        )}
                                        {jourProm > 0 ? (
                                            <Grid
                                                container
                                                justifyContent="space-between"
                                                spacing={2}
                                                style={{
                                                    marginTop: 13,
                                                    marginBottom: 13,
                                                }}
                                            >
                                                <Grid
                                                    item
                                                    md={7}
                                                    lg={7}
                                                    sm={7}
                                                    xs={7}
                                                >
                                                    {location.pathname !== "/search" ? (
                                                        <>
                                                            <span>
                                                                {
                                                                    priceConvertedProm
                                                                }{" "}
                                                                x {jourProm} (-{" "}
                                                                {
                                                                    props
                                                                        .announce
                                                                        .promotion
                                                                        .discount
                                                                }{" "}
                                                                %)
                                                            </span>
                                                        </>
                                                    ) : (
                                                        ""
                                                    )}
                                                </Grid>
                                                <Grid
                                                    item
                                                    md={5}
                                                    lg={5}
                                                    sm={5}
                                                    xs={5}
                                                    style={{ textAlign: 'right' }}
                                                >                                                    
                                                    {priceConvertedTotalProm}
                                                </Grid>
                                            </Grid>
                                        ) : (
                                            ""
                                        )}

                                        <Grid
                                            container
                                            justifyContent="space-between"
                                            spacing={2}
                                            style={{
                                                marginTop: 13,
                                                marginBottom: 13,
                                            }}
                                        >
                                            <Grid
                                                item
                                                md={7}
                                                lg={7}
                                                sm={7}
                                                xs={7}
                                            >
                                                {t(
                                                    "detail-annonce.frais-netoyage"
                                                )}
                                            </Grid>
                                            <Grid
                                                item
                                                md={5}
                                                lg={5}
                                                sm={5}
                                                xs={5}
                                                style={{ textAlign: 'right' }}
                                            >
                                                {priceConvertedClean}
                                            </Grid>
                                        </Grid>

                                        <Grid
                                            container
                                            justifyContent="space-between"
                                            spacing={2}
                                            style={{
                                                marginTop: 13,
                                                marginBottom: 13,
                                            }}
                                        >
                                            <Grid
                                                item
                                                md={6}
                                                lg={6}
                                                sm={6}
                                                xs={6}
                                                style={{ textAlign: 'right' }}
                                            >
                                                <span
                                                    className={
                                                        classes.priceTotal
                                                    }
                                                >
                                                    Total
                                                </span>
                                            </Grid>
                                            <Grid
                                                item
                                                md={6}
                                                lg={6}
                                                sm={6}
                                                xs={6}
                                                style={{ textAlign: 'right' }}
                                            >
                                                <span className={ classes.priceTotal }>
                                                    {priceConvertedFinalProm}
                                                </span>
                                            </Grid>
                                        </Grid>
                                    </>
                                )
                            ) : isNaN(
                                  parseInt(
                                      priceConvertedFinal
                                          .toString()
                                          .replace(currency.toUpperCase(), "")
                                  )
                              ) ||
                              priceConvertedFinal <= 0 ||
                              Number(
                                  priceConvertedTotal
                                      .toString()
                                      .replace(currency.toUpperCase(), "")
                              ) <= 0 ||
                              priceConverted <= 0 ||
                              priceConvertedClean <= 0 ||
                              loadingPrice ? (
                                <CircularProgress
                                    size={16}
                                    style={{ color: "#890608" }}
                                />
                            ) : (
                                <>
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                        spacing={2}
                                        style={{
                                            marginTop: 13,
                                            marginBottom: 13,
                                        }}
                                    >
                                        <Grid item md={8} lg={8} sm={8} xs={8}>
                                            {getTarifLabel(tarif)}
                                        </Grid>
                                        <Grid item md={7} lg={7} sm={7} xs={7}>
                                        {location.pathname !== "/search"  && !location.pathname.startsWith("/stays") ? (
                                                <>
                                                    {priceConverted} x {jour}
                                                </>
                                            ) : (
                                                ""
                                            )}
                                        </Grid>                                       
                                        <Grid
                                            item
                                            md={5}
                                            lg={5}
                                            sm={5}
                                            xs={5}
                                            style={{ textAlign: 'right' }}
                                        >
                                            {priceConvertedTotal}
                                        </Grid>                                      
                                    </Grid>
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                        spacing={2}
                                        style={{
                                            marginTop: 13,
                                            marginBottom: 13,
                                        }}
                                    >
                                        <Grid item md={7} lg={7} sm={7} xs={7}>
                                            {t("detail-annonce.frais-netoyage")}
                                        </Grid>
                                        <Grid item md={5} lg={5} sm={5} xs={5} style={{ textAlign: 'right' }}>
                                            {priceConvertedClean}
                                        </Grid>
                                    </Grid>
                                    {/* Divider */}
                                    <div style={{ borderTop: '1px solid #e0e0e0', margin: '16px 0' }} />

                                    {/* Total for 1 room (always shown) */}
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                        spacing={2}
                                        style={{ marginTop: 13, marginBottom: 13 }}
                                    >
                                        <Grid item md={6} lg={6} sm={6} xs={6}>
                                            <span className={classes.priceTotal}>
                                                {t("label.total_for_room", { count: 1 })}
                                            </span>
                                        </Grid>
                                        <Grid item md={6} lg={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
                                            <span className={classes.priceTotal}>
                                                {priceConvertedFinal}
                                            </span>
                                        </Grid>
                                    </Grid>

                                     {/* Total for selected rooms (only shown for hotels with >1 room selected) */}
                                    {props.searchTypeSearch === 'htls' && selectedRooms > 1 && (
                                        <Grid
                                            container
                                            justifyContent="space-between"
                                            spacing={2}
                                            style={{ marginTop: 13, marginBottom: 13 }}
                                        >
                                            <Grid item md={6} lg={6} sm={6} xs={6}>
                                                <span className={classes.priceTotal}>
                                                    {t("label.total_for_room_plural", { count: selectedRooms })}
                                                </span>
                                            </Grid>
                                            <Grid item md={6} lg={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
                                                <span className={classes.priceTotal}>
                                                    {priceConvertedFinalForSelectedRooms}
                                                </span>
                                            </Grid>
                                        </Grid>
                                    )}
                                </> 
                            )}
                        </>
                    ) : (
                        <div className={classes.errors} style={{ padding: 8 }}>
                            <div className="text_body">
                                <span>
                                    {t(
                                        "reservation.labels.dates-indisponibles"
                                    )}
                                </span>
                            </div>
                        </div>
                    )
                ) : (
                    ""
                )
            ) : (
                ""
            )}
            {props.announce?.state !== "Published" &&
            (location.pathname !== "/search"   && !location.pathname.startsWith("/stays")) ? (
                <>
                    <div className={classes.errors} style={{ padding: 8 }}>
                        <div className="text_body">
                            <span> {t("reservation.labels.non-publiee")} </span>
                        </div>
                    </div>
                </>
            ) : (
                <></>
            )}

            

            {!props.noButton &&
                !icluRes.includes(true) &&
                props.announce?.state === "Published" &&
                moment(
                    preReservation.dci !== "" ? preReservation.dci : new Date()
                ).diff(moment(), "month") < 12 ? (
                <Grid container justifyContent="center" style={{ marginBottom: "13px" }}>
                    {searchTypeSearch === "trs" ? (
                        props.announce?.property?.type?.name === "Circuit" ? (
                            // Show the booking button for "Circuit" type
                            <Button
                                disabled={
                                    !preReservation.dci ||
                                    !preReservation.dco ||
                                    (preReservation.travellerAdultTotal <= 0 &&
                                        preReservation.travellerChildTotal <= 0)
                                }
                                onClick={handleReservation}
                                className={classes.submit}
                            >
                                {t("label.reserverNow")}
                            </Button>
                        ) : (
                            // Show the "Find Circuits" button for other "trs" types
                            <FindCircuitsPopup
                                buttonClassName={classes.submit}
                                buttonStyle={{ background: "#25d366", color: "white" }}
                            />
                        )
                    ) : (
                        // Default booking button for non-"trs" search types
                        <>
                            <Button
                                disabled={
                                    !preReservation.dci ||
                                    !preReservation.dco ||
                                    (preReservation.travellerAdultTotal <= 0 &&
                                        preReservation.travellerChildTotal <= 0)
                                }
                                onClick={handleReservation}
                                className={classes.submit}
                                style={{ marginBottom: 15}}
                            >
                                {t("label.reserverNow")}
                            </Button>
                            <Grid xs={12}>
                                <Grid container spacing={2} justifyContent="center" alignItems="center">
                                    {paymentLogos.map((logo, index) => (
                                    <Grid item key={index}>
                                        <img
                                        src={logo}
                                        alt={`payment-method-${index}`}
                                        style={{
                                            width: "50px",
                                            height: "50px",
                                            objectFit: "contain",
                                            borderRadius: "4px",
                                        }}
                                        /> 
                                    </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </>
                    )}               
                </Grid>
            ) : (
                <>
                    {(location.pathname !== "/search"   && !location.pathname.startsWith("/stays")) && (
                        <div className={classes.errors} style={{ padding: 8 }}>
                            <div className="text_body">
                                <h3>
                                    {t(
                                        "reservation.labels.vous-ne-pouvez-pas-reserver"
                                    )}
                                </h3>
                            </div>
                        </div>
                    )}
                </>
            )} 
        </>
        )}                    
            <Grid
                style={{
                    background: "#FF6E6E33",
                    padding: 12,
                    marginTop: 20,
                    lineHeight: "25px",
                    color: "#FF6E6E",
                }}
            >
                <div className="text_body">
                    {searchTypeSearch === "trs" ? (
                        // Message for "trs" case
                        <>
                            * {t("detail-annonce.protection1-trs")}
                        </>
                    ) : (
                        // Message for all other cases
                        <>
                            * {searchTypeSearch === "apts" || searchTypeSearch === "htls"
                                ? t("detail-annonce.protection1")
                                : searchTypeSearch === "cars"
                                ? t("detail-annonce.protection1-v")
                                : searchTypeSearch === "evts"
                                ? t("detail-annonce.protection1-e")
                                : ""}{" "}
                            <span>{t("detail-annonce.protection2")}</span>
                            <br />
                            {t("detail-annonce.protection3")}
                        </>
                    )}
                </div>
            </Grid>
           </div> 

            <LoginDialog
                open={openDialog}
                handleClose={handleCloseLoginDialog}
                handleClickOpenRegister={handleClickOpenRegister}
                redirectPath={history.location.pathname + history.location.search}
            />
            <RegisterDialog
                open={openRegister}
                handleClose={handleCloseRegister}
                handleOpenLoginDialog={handleClickOpenLoginDialog}
                redirectPath={history.location.pathname + history.location.search}
            />
        </>
    );
};

/** MAIN COMPONENT */
export const ReservationCard: React.FC<IReservationCardProps> = (props) => {
    const elRef = React.useRef<HTMLElement | null>(null);
    const elContainerRef = React.useRef<HTMLDivElement | null>(null);
    const classes = useStyles();

    React.useEffect(() => {
        const handleScroll = (e: any) => {
            if (elRef.current && elContainerRef.current) {
                let elContainer = elContainerRef.current as HTMLDivElement;
                let el = elRef.current as HTMLElement;
                let rect = elContainer.getBoundingClientRect();
                let paddingY = 12;
                let paddingTop = 100 + paddingY;

                if (
                    rect.top <= paddingTop &&
                    window.innerHeight + window.scrollY <
                        document.body.offsetHeight
                ) {
                    if (el.style.position !== "fixed") {
                        el.style.position = "fixed";
                        el.style.removeProperty("bottom");
                        el.style.top = paddingTop + "px";
                        el.style.zIndex = "100";
                        elContainer.style.height = el.offsetHeight + "px";
                        el.style.maxWidth = "395px";
                    }
                } else {
                    if (el.style.position !== "relative") {
                        el.style.position = "relative";
                        el.style.maxWidth = "auto";
                        el.style.removeProperty("bottom");
                        el.style.removeProperty("top");
                        elContainer.style.height = "auto";
                    }
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return props.isEmbed ? (
        <ReservationCardContent {...props} />
    ) : (
        <div ref={elContainerRef} className={classes.paper}>
            <Paper
                elevation={2}
                style={{
                    padding: 24,
                    boxShadow: "0 30px 40px 0 rgb(16 36 94 / 20%)",
                    width: "100%",
                    //maxHeight: "80vh", // Set a maximum height for the card
                    //overflowY: "auto", // Enable vertical scrolling when content overflows
                }}
                ref={elRef}
            >
                <ReservationCardContent {...props} />
            </Paper>
        </div>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            [theme.breakpoints.down("sm")]: {
                maxWidth: "100%!important",
            },
            //maxHeight: "80vh", // Set a maximum height
            //overflowY: "auto", // Enable vertical scrolling
        },
        searchButton: {
            padding: "9px 20px",
            fontSize: 14,
            color: "white",
            textTransform: "capitalize",
            background: "#890608 !important",
            borderRadius: 150,
            fontFamily: "Josefin Sans",
            "&:hover": {
                background: "#B5551B !important",
            },
        },
        price: {
            color: "#EA7606",
            fontSize: 20,
        },
        errors: {
            color: colors.danger,
            background: colors.backgroundDanger,
            width: "100%",
            textAlign: "center",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            borderRadius: 5,
            "& p": {
                padding: 10,
            },
        },
        price_title: {
            color: colors.danger,
            background: colors.backgroundDanger,
            width: "100%",
            textAlign: "center",
            paddingTop: 12,
            paddingBottom: 12,
            marginTop: 24,
        },
        date_item_title: {
            fontSize: "14px",
            paddingTop: 14,
            paddingBottom: 6,
        },
        submit: {
            width: "80%",
            backgroundColor: "#890608",
            borderRadius: 100,
            "&:hover": {
                background: "#EA7606",
            },
            "&.MuiButton-root": {
                color: "white",
                textTransform: "capitalize",
            },
        },
        button_root: {
            textTransform: "capitalize",
        },
        input_base_root: {
            color: "#AAAAAA",
            border: "1px solid #EA7606",
            borderRadius: 4,
            "& .MuiInput-underline:before": {
                display: "none",
            },
            "& .MuiInput-underline:after": {
                display: "none",
            },
            "& .MuiInputBase-input.Mui-disabled": {
                color: "#222",
            },
        },
        form_control: {
            color: "#AAAAAA",
            border: "1px solid #EA7606",
            borderRadius: 4,
        },
        icon_button_root: {
            padding: 0,
            width: 28,
        },
        priceTotal: {
            fontSize: "18px",
            color: "#EA7606",
        },       
        phoneNumber: {
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
        },
        icon: {
            marginRight: "8px",
        },
        scrollableContent: {
            maxHeight: 'calc(100vh - 200px)', // Adjust this value as needed
            overflowY: 'auto',
            paddingRight: theme.spacing(1), // Add some padding to prevent scrollbar overlap
            
            // Custom scrollbar styling for better appearance
            '&::-webkit-scrollbar': {
                width: '6px',
            },
            '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: '10px',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '10px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
            },
        },
        button: {
            background: "#890608",
            color: "white",
            borderRadius: 100,
            fontFamily: "Josefin Sans",
            fontSize: 14,
            textTransform: "none",
            padding: "8px 14px",
            margin: "0 auto 30px auto",
            display: "flex",
            "&:hover": {
                background: "#B5551B",
            },
            "&:disabled": {
                color: "#999",
            },
        },
    })
);
